import { css } from '@emotion/core';

export const menuDividerCSS = css`
    margin: 0.25rem 0;
`;
